// redep
import React from "react";
import styled from "styled-components/macro";
import { Paper } from "@mui/material";
import { List } from "react-feather";
import { QUESTION_TYPES } from "../../../../../storage/constants";
import TrueFalse from "./TrueFalse";
import MultipleChoice from "./MultipleChoice";
import SelectAll from "./SelectAll";

const Wrapper = styled(Paper)`
  width: 100%;
  min-height: 200px;
`;

const Header = styled.div`
  height: 64px;
  border-bottom: 1px solid lightgray;
  width: 100%;
  padding: 0px 24px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 12px;

  span {
    font-size: 16px;
    font-weight: 600;
  }

  svg {
    height: 13px;
    width: 13px;
    color: #337ab7;
  }
`;

const Body = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-direction: column;
  min-height: 200px;
  flex: 1;
  padding: 12px;
  gap: 8px;
`;

const DisplayQuestionBreakdown = ({ question }) => {
  if (question.type === QUESTION_TYPES.TRUE_FALSE) {
    return <TrueFalse question={question} />;
  }
  if (question.type === QUESTION_TYPES.SELECT_ALL) {
    return <SelectAll question={question} />;
  }

  return <MultipleChoice question={question} />;
};

const QuestionsReport = ({ questions }) => {
  return (
    <Wrapper>
      <Header>
        <List />
        <span>Questions</span>
        <p style={{ marginLeft: "auto", color: "darkgrey", fontSize: 12 }}>
          Module has {questions?.length}{" "}
          {questions?.length === 1 ? "question" : "questions"}
        </p>
      </Header>
      <Body>
        {questions?.length === 0 ? (
          <span style={{ color: "darkgrey" }}>Module has no questions</span>
        ) : (
          questions.map((question) => (
            <DisplayQuestionBreakdown
              key={question.order}
              question={question}
            />
          ))
        )}
      </Body>
    </Wrapper>
  );
};

export default QuestionsReport;
